export const adminMenus = [
    {
        name: 'ড্যাসবোর্ড',
        stack: 'AdminScreen',
        screen: 'AdminScreen',
    },
    {
        name: 'জি আর শাখা আদালত',
        stack: 'অ্যাডমিন',
        screen: 'grBranchAdalot',
    },
    {
        name: 'জি আর থানা/অঞ্চল',
        stack: 'অ্যাডমিন',
        screen: 'grThanaArea',
    },
    {
        name: 'জি আর কার্জতালিকার ছবি',
        stack: 'অ্যাডমিন',
        screen: 'grAdalotCreate',
    },
    {
        name: 'অফলাইন আদালত',
        stack: 'অ্যাডমিন',
        screen: 'OfflineAdalot',
    },
    {
        name: 'অফলাইন ডায়েরী',
        stack: 'অ্যাডমিন',
        screen: 'OfflineDairy',
    },
    {
        name: 'কার্যতালিকার ছবি',
        stack: 'অ্যাডমিন',
        screen: 'AllAdalotImageCreate',
    },
    {
        name: 'জি আর সকল কার্যতালিকার ছবি',
        stack: 'অ্যাডমিন',
        screen: 'grAllImageUpload',
    },
    {
        name: 'নন জি আর সকল কার্যতালিকার ছবি',
        stack: 'অ্যাডমিন',
        screen: 'nonGrAllImageUpload',
    },
];